const NAME_LS_SAVE = 'EDX_SAVE';

const setItem = (name, data) => localStorage.setItem(name, JSON.stringify(data));
const removeItem = (name) => localStorage.removeItem(name);
const getItem = (name) => JSON.parse(localStorage.getItem(name));

export const loadField = ({ field }) => {
  const lsData = getItem(NAME_LS_SAVE);
  return lsData ? lsData[field] : null;
};

export const updateField = ({ field, data }) => {
  const lsData = getItem(NAME_LS_SAVE);
  setItem(NAME_LS_SAVE, { ...(lsData || {}), [field]: data });
};

export const removeField = ({ field }) => updateField({ field, data: null });

export const remove = () => removeItem(NAME_LS_SAVE);
